import React, { useCallback } from "react";
import { useIntl, defineMessages } from "react-intl";
import Link from "theme/components/atoms/Typography/Link";
import Icon from "theme/components/atoms/Icon";
import { IconButton } from "theme/components/atoms/Button";
import { useHistory } from "react-router";
import useDifferedClick from "./useDifferedClick";

const loginPath = {
  pathname: "/login",
  state: { modal: true },
};

const messages = defineMessages({
  account: {
    id: "layouts.Header.Navigation.account",
    defaultMessage: "My Account",
  },
  loading: {
    id: "layouts.Header.Navigation.loading",
    defaultMessage: "Loading user information...",
  },
  signin: {
    id: "layouts.Header.Navigation.signin",
    defaultMessage: "Sign in",
  },
});

const AccountIcon = ({ loading, user, onUserMenu }) => {
  const intl = useIntl();

  const history = useHistory();

  const [isClicked, onLoadingClick] = useDifferedClick(
    loading,
    useCallback(() => {
      if (!user) {
        return false;
      }

      if (user.id) {
        onUserMenu();
      } else {
        history.push(loginPath);
      }
    }, [user, history, onUserMenu])
  );

  return loading ? (
    <IconButton
      icon="user"
      title={intl.formatMessage(messages.loading)}
      onClick={() => {
        onLoadingClick(true);
      }}
      state={isClicked ? "pending" : undefined}
    />
  ) : user?.id ? (
    <IconButton
      icon="user"
      title={intl.formatMessage(messages.account)}
      onClick={() => onUserMenu()}
    />
  ) : (
    <Link to={loginPath} buttonAppearance="icon">
      <Icon
        appearance="default-block"
        icon="user"
        title={intl.formatMessage(messages.signin)}
      />
    </Link>
  );
};

export default AccountIcon;
